module.exports = __webpack_public_path__ + "build/desktop/img/home.362ba61e541a88553208f72e854e4a84.svg";